import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Box, TextField, Button, Grid, Container, Paper, Typography, Select, MenuItem, FormControl,
    InputLabel, IconButton, Checkbox, FormControlLabel
} from '@mui/material';
import DataTable from 'react-data-table-component';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { LobService } from '../services/lobService';
import { useNavigate } from 'react-router-dom';
import { resetTabState, setContractsOld } from '../Redux/TabDucks';
import { SearchService } from '../services/SearchService';
import { setCargaDatos } from '../Redux/GeneralDuck';
import { formatToCLP } from '../services/monedaService';//'../services/monedaService';
import moment from 'moment';

import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const ContractSearchPage = ({ myAccount }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false); // Estado para el cargando
    const [filteredItems, setFilteredItems] = useState([]); // Datos filtrados para la tabla
    const [myAccountData, setMyAccountData] = useState(null);
    const _GENERAL = useSelector((store) => store.general);

    const [searchCriteria, setSearchCriteria] = useState({
        Desde: null,
        Hasta: null,
        Identifier: null,
        LineNegocio: null,
        Validado: null,
        NoValidado: null,
        Confirmado: null,
        NoConfirmado: null,
        Cancelado: null,
        Finiquitado: null,
        //Estado: ''
    });

    const columns = [
        {
            name: 'Codigo contrato',
            selector: row => row.codCtto,
            sortable: true,
            width: "240px",
            cell: row => <Button className='p-1' style={{ width: "230px" }} variant='outlined' onClick={() => HandleOpenCtto(row)}>{row.codCtto}</Button>,
        },
        {
            name: 'Negocio',
            selector: row => (row.lineOfBusiness ? row.lineOfBusiness.split(' ').slice(1).join(' ') : ''),
            sortable: true,
            width: "100px",
        },
        {
            name: 'Rut',
            selector: row => row.identifier,
            sortable: true,
            width: "auto",
            width: "106px",
        },
        {
            name: 'Defendido',
            selector: row => row.name,
            sortable: true,
            width: "190px"//,
        },
        {
            name: 'Firmado',
            selector: row => row.confirmationDate ? new Date(row.confirmationDate) : null,
            format: row => row.confirmationDate ? moment(row.confirmationDate).format("DD/MM/YYYY") : "NO",
            sortable: true,
            width: "105px",
        },
        {
            name: 'Validado',
            selector: row => row.validationDate ? new Date(row.validationDate) : null,
            format: row => row.validationDate ? moment(row.validationDate).format("DD/MM/YYYY") : "NO",
            sortable: true,
            width: "105px",
        },
        {
            name: 'Atendido Por',
            selector: row => row.atendidoPor,
            sortable: true,
            width: "140px",
        },
        {
            name: 'Monto',
            selector: row => formatToCLP(row.monto ?? 0),
            sortable: true,
            width: "110px",
        },
        {
            name: 'Creado',
            selector: row => row.createAt ? new Date(row.createAt) : null,
            format: row => moment(row.createAt).format("DD/MM/YYYY"),
            sortable: true,
            width: "105px",
        },
        {
            name: 'Estado',
            selector: row => row.statusContract,
            sortable: true,
            width: "182px",
        }
    ];

    const HandleOpenCtto = async (row) => {
        navigate('/TabularPageV2', { state: { customerInterviewId: row.customerInterviewId } })
    }

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        const exclusives = {
            Validado: "NoValidado",
            NoValidado: "Validado",
            Confirmado: "NoConfirmado",
            NoConfirmado: "Confirmado",
        };

        setSearchCriteria(prevState => {
            const updated = {
                ...prevState,
                [name]: type === "checkbox" ? (checked ? true : null) : value
            };

            const exclusiveField = exclusives[name];
            if (exclusiveField) {
                updated[exclusiveField] = null;
            }

            return updated;
        });
    };

    const handleSearch = async (e) => {

     console.log("Borrando variable de sesion customerInterviewId en Buscar  Contrato");

        sessionStorage.removeItem("customerInterviewId");

        e.preventDefault();
        dispatch(resetTabState());
        setLoading(true);
        // Simulación de búsqueda (reemplazar con la llamada real a la API)
        var auxForm = searchCriteria
        for (var propName in auxForm)
            if (auxForm[propName] === null || auxForm[propName] === undefined || auxForm[propName] === "") delete auxForm[propName]

        if (myAccount)
            auxForm["AtendidoPor"] = myAccount.get('identifier')


        await setTimeout(async () => {
            const contratos = await LobService.getSearchInterview(auxForm);
            setFilteredItems(contratos);
            setLoading(false);
        }, 300);
    };

    const subHeaderComponentMemo = React.useMemo(() => {
        return (
            <div>
                {/* Componente opcional para incluir filtros adicionales o botones */}
            </div>
        );
    }, []);

    const customStyles = {
        table: {
            style: {
                minWidth: 'auto',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#F2F2F7',
                borderBottom: 'none',
                window: 'auto',
            },
        },
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: '600',
                color: '#86868B',
                textTransform: 'uppercase',
            },
        },
        cells: {
            style: {
                fontSize: '14px',
                color: '#1D1D1F',
            },
        },
    };

    useEffect(() => {
        dispatch(setCargaDatos())
    }, [])

    const exportToExcel = async () => {

        var auxForm = searchCriteria
        for (var propName in auxForm)
            if (auxForm[propName] === null || auxForm[propName] === undefined || auxForm[propName] === "") delete auxForm[propName]

        if (myAccount)
            auxForm["AtendidoPor"] = myAccount.get('identifier')

        const contratos = await LobService.getSearchInterviewExcel(auxForm);

        console.log(contratos)
        const filteredData = contratos.map(item => ({
            'Cliente': item.name,
            'Rut': item.identifier,
            'Cod Ctto': item.codCtto,
            'Linea Negocio': (item.lineOfBusiness ? item.lineOfBusiness.split(' ').slice(1).join(' ') : ''),
            'Firmado': item.confirmationDate ? moment(item.confirmationDate).format("DD/MM/YYYY") : 'NO',
            'Validado': item.validationDate ? moment(item.validationDate).format("DD/MM/YYYY") : 'NO',
            'Atendido Por': item.atendidoPor,
            'Monto': item.monto ?? 0,
            'Fono Defendido': item.fonoDefendido ?? 'no definido',
            'Nombre Pagador': item.nombrePagador ?? 'no definido',
            'Fono Pagador': item.fonoPagador ?? 'no definido',
            'Metodo Pago': item.metodoPago ?? 'no definido',
            'Servicio': item.servicio ?? 'no definido',
            'Numero Cuotas': item.numeroCuotas ?? 'no definido',
            'Valor Cuota': item.valorCuota ?? 'no definido',
            'Creado': moment(item.createAt).format("DD/MM/YYYY"),
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredData); // conviertes tu data
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });


        const file = new Blob([excelBuffer], { type: 'application/octet-stream' });

        saveAs(file, 'Contratos_' + (moment(new Date()).format("DD_MM_YYYY")) + '.xlsx');
    };
    const isDataEmpty = !filteredItems || filteredItems.length === 0;


    return (
        <Container maxWidth="lg">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography className='mb-4' variant="h5" gutterBottom>
                    Búsqueda de Contratos
                </Typography>
                <Box component="form" noValidate autoComplete="off" onSubmit={handleSearch}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="Desde"
                                label="Fecha Inicio"
                                name="Desde"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={searchCriteria.Desde}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="Hasta"
                                label="Fecha Fin"
                                name="Hasta"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={searchCriteria.Hasta}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel id="LineNegocio-label">Línea de Negocios</InputLabel>
                                <Select
                                    labelId="LineNegocio-label"
                                    id="LineNegocio"
                                    name="LineNegocio"
                                    value={searchCriteria.LineNegocio}
                                    onChange={handleChange}
                                >
                                    <MenuItem value=""><em>-- Selecciona una opción --</em></MenuItem>
                                    {_GENERAL.negocios.map((negocio, index) => (
                                        <MenuItem key={index} value={negocio.id}>{negocio.name}</MenuItem>
                                    ))}
                                    {/* Opciones de Línea de Negocios */}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="Identifier"
                                label="RUT Defendido"
                                name="Identifier"
                                value={searchCriteria.Identifier}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchCriteria.Confirmado || false} // Estado del checkbox
                                        onChange={handleChange}
                                        id="Confirmado"
                                        label="Confirmado"
                                        name="Confirmado"
                                        color="primary"
                                    />
                                }
                                label="Contratos Confirmados"
                            />
                            <br />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchCriteria.NoConfirmado || false} // Estado del checkbox
                                        onChange={handleChange}
                                        id="NoConfirmado"
                                        label="NoConfirmado"
                                        name="NoConfirmado"
                                        color="primary"
                                    />
                                }
                                label="Contratos No Confirmados"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchCriteria.Validado || false} // Estado del checkbox
                                        onChange={handleChange}
                                        id="Validado"
                                        label="Validado"
                                        name="Validado"
                                        color="primary"
                                    />
                                }
                                label="Contratos Validados"
                            />
                            <br />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchCriteria.NoValidado || false} // Estado del checkbox
                                        onChange={handleChange}
                                        id="NoValidado"
                                        label="NoValidado"
                                        name="NoValidado"
                                        color="primary"
                                    />
                                }
                                label="Contratos No Validados"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchCriteria.Cancelado || false} // Estado del checkbox
                                        onChange={handleChange}
                                        id="Cancelado"
                                        label="Cancelado"
                                        name="Cancelado"
                                        color="primary"
                                    />
                                }
                                label="Incluir Cancelados"
                            />
                            <br />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={searchCriteria.Finiquitado || false} // Estado del checkbox
                                        onChange={handleChange}
                                        id="Finiquitado"
                                        label="Finiquitado"
                                        name="Finiquitado"
                                        color="primary"
                                    />
                                }
                                label="Incluir Finiquitados"
                            />
                        </Grid>

                    </Grid>
                    <Box sx={{ mt: 1, display: 'flex', justifyContent: 'right' }}>
                        <Button variant="contained" type="submit" size="large" > Buscar </Button>
                    </Box>
                </Box>
            </Paper>
            <Paper className="apple-card" sx={{ p: 2, marginTop: '10px' }}>
                <Button variant="contained" onClick={exportToExcel} hidden={isDataEmpty}>Descargar Excel</Button>
                <DataTable
                    columns={columns}
                    data={filteredItems}
                    progressPending={loading}
                    pagination
                    paginationPerPage={20}
                    paginationRowsPerPageOptions={[20, 30, 50, 100, 200]}
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    customStyles={customStyles}
                />
            </Paper>

            {/*             <div className="apple-container" style={{ marginTop: '10px'}}>

                <footer style={{ textAlign: 'center', marginTop: '20px' }}>
                    <p>© {new Date().getFullYear()} Generador de Contratos. Todos los derechos reservados Grupo Defensa. Desarrollado por Gerencia IT</p>
                </footer>
            </div> */}

            <footer style={{ textAlign: 'left', marginTop: '20px' }}>
                <p>© {new Date().getFullYear()} Generador de Contratos v2.0.1. Todos los derechos reservados Grupo Defensa. Desarrollado por el area de Tecnología</p>
            </footer>

        </Container>
    );
};

export default ContractSearchPage;
